var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38,30h4c0.6,0,1-0.4,1-1v-3h14v3c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1v-3c0-3.3-2.7-6-6-6H43c-3.3,0-6,2.7-6,6 v3C37,29.6,37.4,30,38,30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74,36H26c-3.3,0-6,2.7-6,6v32c0,3.3,2.7,6,6,6h48c3.3,0,6-2.7,6-6V42C80,38.7,77.3,36,74,36z M37.9,47.1 l24.3,0c0.8,0,0.9,0.7,0.7,1.1L50.6,59.6c-0.3,0.3-0.8,0.3-1.2,0L37.2,48.3C36.7,47.7,37.2,47.1,37.9,47.1z M63,64 c0,1.4-1.6,3-3,3H40c-1.4,0-3-1.6-3-3c0,0,0-7.4,0-10.9c0-0.6,0.7-0.9,1.1-0.5l9.6,8.9c0.6,0.6,1.5,0.9,2.3,0.9s1.7-0.3,2.3-0.9 l9.5-8.9c0.4-0.4,1.1-0.2,1.1,0.3C63,53.8,63,63.7,63,64z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.ab1ef17370110737aa7120045c7d829d.svg";
export { ForwardRef as ReactComponent };